import(/* webpackMode: "eager", webpackExports: ["default"] */ "/src/src/app/(activity)/mob-wife-style-glasses/components/MobWifeStyleGlassesClient.tsx");
